<template>
  <vs-sidebar
    click-not-close
    hidden-background
    position-right
    v-model="active"
    class="items-no-padding department-edit">
    <div class="h-full">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div class="dialog-title">
          {{title}}
        </div>
        <feather-icon
          icon="XIcon"
          @click.stop="closeHandle"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl">

        <div class="px-6">
          <el-form
            :model="form"
            :rules="rules"
            hide-required-asterisk
            label-position="top"
            ref="form"
          >
            <el-form-item
              label="商户"
              prop="merId"
            >
              <el-select
                v-model="form.merId"
                placeholder="请输入"
                clearable
              >
                <el-option
                  v-for="(item, index) in merchants"
                  :key="index"
                  :label="item.merName"
                  :value="item.id"
                ></el-option>
              </el-select>

            </el-form-item>
            <el-form-item
              label="产品"
              prop="productId"
            >
              <el-select
                v-model="form.productId"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item, index) in products"
                  :key="index"
                  :label="item.productName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="状态"
              prop="status"
              class="blod-form-item"
            >
              <vs-radio
                v-model="form.status"
                vs-name="radios1"
                class="mar-right10"
                :vs-value="0"
              >启用</vs-radio>
              <vs-radio
                v-model="form.status"
                vs-name="radios1"
                class=""
                :vs-value="1"
              >禁用</vs-radio>
            </el-form-item>
            <el-form-item>
              <vs-button @click="submit" class="mar-right10" type="filled" color="primary">确认</vs-button>
              <vs-button @click="cancel" type="border"  color="primary">取消</vs-button>
            </el-form-item>
          </el-form>
        </div>
      </VuePerfectScrollbar>
    </div>
  </vs-sidebar>
</template>

<script>
  import { queryValidProducts } from '@/api/product'
  import { queryValidMerchants, createMerProdRelation,updateMerProdRelation } from '@/api/merchan'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    export default {
        name: "editOrAdd",
      props: {
        active: {
          type: Boolean,
          default: false
        },
        isEdit:{
          type: Boolean,
          default: false
        },
        editData:{
          type: Object,
          default(){
            return {
              merId: '',
              productId: '',
              status: 0,
            }
          }
        }
      },
      components: {
        VuePerfectScrollbar,
      },
      data() {
        return {
          settings: {
            maxScrollbarLength : 60,
            wheelSpeed         : .60,
          },
          form:{
            merId: '',
            productId: '',
            status: 0,
          },
          rules:{
            // 名字有长度限制以及不能输入空格
            merId:[
              { required: true, message: '请选择', trigger: 'change' }
            ],
            productId:[
              { required: true, message: '请选择', trigger: 'change' }
            ],
          },
          merchants: [],
          products: [],
        }
      },
      created(){
          this.getMerchans();
          this.getProducts();
      },
      watch: {
        editData(newValue, oldValue) {
          if(newValue.id){
            this.form.id = newValue.id;
            this.form.merId = newValue.merId;
            this.form.productId = newValue.productId;
            this.form.status = newValue.status;
          }else {
            this.form = {
              merId: '',
              productId: '',
              status: 0,
            }
          }
        },
        active(newValue){
          if(newValue){
            this.$nextTick(() => {
              this.$refs.form.clearValidate();
            })
            this.getProducts();
          }
        }
      },
      computed: {
        title() {
          return this.isEdit ? '编辑': '添加';
        }
      },
      methods: {
          getProducts(){
            queryValidProducts({isValid: 1}).then((res) => {
              this.products = res.data;
            })
          },
        getMerchans(){
          queryValidMerchants({isValid: 1}).then((res) => {
            this.merchants = res.data;
          })
        },
        close(){
          this.$emit('close')
        },
        reset(){
          this.form = {
            merId: '',
            productId: '',
            status: 0,
          };
        },
        closeHandle() {
          this.$refs.form.resetFields();
          this.close();
        },
        cancel(){
          this.$refs.form.resetFields();
          this.close();
        },
        // 需要重置为初始化状态: 1.添加成功或者编辑成功, 2.添加操作
        submit(){
            this.$refs.form.validate((valid) => {
              if(valid){
                // ajax
                if(this.isEdit){
                  updateMerProdRelation(this.form).then((res) => {
                    this.close();
                    this.reset();
                    this.$emit('done-success');
                    this.$vs.notify({
                      text: '操作成功',
                      position: 'top-right'
                    })
                  });
                }else {
                  createMerProdRelation(this.form).then((res) => {
                    this.close();
                    this.$emit('done-success');
                    this.$vs.notify({
                      text: '操作成功',
                      position: 'top-right'
                    })
                  });
                }
              }else {
                console.log('no-pass');
              }
            })
        }
      },
    }
</script>

<style lang="scss">
  .department-edit {
    .vs-sidebar {
      position: fixed;
      z-index: 999;
      width: 360px;
      max-width: 90vw;
      // @apply shadow-lg;
      box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08);
    }
    .scroll-area--customizer {
      height: calc(100% - 5rem);
    }
    .el-select {
      width: 100%;
    }
  }


</style>
